import { render, staticRenderFns } from "./IndexJiazhang03.vue?vue&type=template&id=b6706d94&scoped=true&"
import script from "./IndexJiazhang03.vue?vue&type=script&lang=js&"
export * from "./IndexJiazhang03.vue?vue&type=script&lang=js&"
import style0 from "./IndexJiazhang03.vue?vue&type=style&index=0&id=b6706d94&prod&lang=scss&"
import style1 from "./IndexJiazhang03.vue?vue&type=style&index=1&id=b6706d94&prod&lang=scss&scoped=true&"
import style2 from "./IndexJiazhang03.vue?vue&type=style&index=2&id=b6706d94&prod&lang=scss&"
import style3 from "./IndexJiazhang03.vue?vue&type=style&index=3&id=b6706d94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6706d94",
  null
  
)

export default component.exports